import api from "../store/services/api";

export const getDrivers = async (params) =>
  await api.get("/drivers/", { params });

export const getDriversReportData = async (params) =>
  await api.get("/new/delivery-driver-rank/", { params });

export const getDriversOrders = async (params = null) =>
  await api.get("/drivers/orders/", { params });

export const getDriversOrdersReport = async (params) =>
  await api.get("/drivers/orders/report/", { params });

export const createDriver = async (driver) =>
  await api.post("/drivers/", driver, {
    headers: { "Content-Type": "application/json" },
  });

export const editDriver = async (driver, driverId) =>
  await api.put(`/drivers/?did=${driverId}`, driver, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDriver = async (driverId) =>
  await api.delete(`/drivers/?did=${driverId}`);

export const dispatchOrdersCombo = async (
  driverId,
  orders,
  equipmentId = undefined
) =>
  await api.post(`/orders/dispatch/combo/`, { driverId, orders, equipmentId });

const DriversService = {
  getDrivers,
  getDriversReportData,
  getDriversOrders,
  getDriversOrdersReport,
  createDriver,
  editDriver,
  deleteDriver,
};

export default DriversService;
